export default "__VITE_ASSET__CtIi6QY4__"